module.exports = __webpack_public_path__ + "files/valentin.bb6c0846cefa35d3117ff413ab61890c.pdf";